import React, { lazy, Suspense, memo } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Loader } from '@shared-components';
import { useSelector } from 'react-redux';
import {
	isEmployeeDashboardPermission,
	selectIsAuthenticated,
	isViewAccountsListPermission,
} from '@store/userData/selectors';

const UsersLayout = lazy(() => import('../views/UsersLayout/UsersLayout'));
const LoggedOut = lazy(() => import('../views/LoggedOut/LoggedOut'));
const SystemError = lazy(() => import('../views/SystemError/SystemError'));
const AccessDenied = lazy(() => import('../views/AccessDenied/AccessDenied'));
const AuthorizationFailed = lazy(() => import('../views/AuthorizationFailed/AuthorizationFailed'));
const PageNotFound = lazy(() => import('../views/PageNotFound/PageNotFound'));
const SessionHistory = lazy(() => import('../views/HistoryPage/HistoryPage'));
const HomePage = lazy(() => import('../views/HomePage/HomePage'));
const Accounts = lazy(() => import('../views/AccountsPage/AccountsPage'));
const Login = lazy(() => import('../Components/Login/Login'));

const Routes = () => {
	const isAdmin = useSelector(isEmployeeDashboardPermission);
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const isAccountList = useSelector(isViewAccountsListPermission);

	return (
		<Suspense fallback={<Loader fullscreen={true} />}>
			<Switch>
				<Route exact path="/login" component={Login} />
				<Route exact path="/access-denied" component={AccessDenied} />
				<Route exact path="/authorization-failed" component={AuthorizationFailed} />
				<Route exact path="/system-error" component={SystemError} />
				<Route exact path="/logged-out" component={LoggedOut} />
				<Route exact path="/page-not-found" component={PageNotFound} />
				<Route path="/home" component={() => (isAdmin ? <HomePage /> : <Redirect to="/page-not-found" />)} />
				<Route path="/sessions" component={UsersLayout} />
				<Route
					path="/accounts"
					component={() => (isAccountList ? <Accounts /> : <Redirect to="/page-not-found" />)}
				/>
				<Route path="/sessions-history" component={SessionHistory} />
				{isAuthenticated ? (
					<Redirect exact path="/" to={isAdmin ? '/home' : '/sessions'} />
				) : (
					<Redirect exact path="/" to="login" />
				)}
				<Route component={PageNotFound} />
			</Switch>
		</Suspense>
	);
};

export default memo(Routes);
